// @flow
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import NaurService from '../../services/naurService';
import useAbortController from '../useAbortController';

/**
 * Cheap, always-200 check of whether this property's one-time applicable fraction
 * initialization has already run. Fetches on page load (enabled by default with both ids).
 *
 * A property that was never initialized returns alreadyInitialized: false with both stamps null.
 * That is the normal answer, not an error.
 */
const useApplicableFractionInitializationState = ({
  organizationId,
  propertyId,
}: {
  organizationId: ?string,
  propertyId: ?string,
}) => {
  const naurService = useMemo(() => new NaurService(), []);
  const abortControllerOptions = useAbortController();

  return useQuery(
    ['applicable-fraction-initialization-state', propertyId],
    () =>
      naurService.getApplicableFractionInitializationState(
        organizationId,
        propertyId,
        abortControllerOptions,
      ),
    {
      enabled: Boolean(organizationId && propertyId),
      retry: false,
      refetchOnWindowFocus: false,
    },
  );
};

export default useApplicableFractionInitializationState;
